<template>
  <div>
    <div class="row">
      <slot />
    </div>
    <div class="row mt-3">
      <div class="col-4 text-start currentStep">
        <button
          v-if="!isFirstStep"
          class="btn btn-md btn-outline-success"
          type="button"
          @click="$emit('previousStep')"
        >{{backButtonText}}</button>
      </div>
      <div class="col-4 text-center">
        <span class="fw-bold">{{ currentStep }} / {{maxSteps}}</span>
      </div>
      <div class="col-4 text-end">
        <button
          class="btn btn-md btn-outline-success"
          :disabled="isNextButtonDisabled"
          type="button"
          @click="$emit('nextStep')"
        >{{ this.currentStep === this.maxSteps ? this.finishButtonText : this.nextButtonText }}</button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    currentStep: {
      type: Number,
      default: 0,
      validator(value) {
        return value >= 0;
      },
      required: true,
    },
    maxSteps: {
      type: Number,
      validator(value) {
        return value > 0;
      },
      required: true,
    },
    isNextButtonDisabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    nextButtonText: {
      type: String,
      required: true,
    },
    backButtonText: {
      type: String,
      required: true,
    },
    finishButtonText: {
      type: String,
      required: true,
    },
  },
  data: () => ({}),
  computed: {
    isFirstStep() {
      return this.currentStep === 1;
    },
  },
  methods: {

  },
};
</script>
